import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

const ID = 'arc-portal-container'

/**
 * Utility for rendering ReactDOM portals.
 * Currently does not support server-side rendering
 */
export const Portal: React.FC = ({ children }) => {
  const [el] = useState(document.createElement('div'))

  const [container] = useState(() => {
    let foundContainer = document.getElementById(ID)
    if (!foundContainer) {
      foundContainer = document.createElement('div')
      foundContainer.setAttribute('id', ID)
      document.body.appendChild(foundContainer)
    }
    return foundContainer
  })

  useEffect(
    () => () => {
      el.remove()
    },
    [el]
  )

  container.appendChild(el)
  return ReactDOM.createPortal(children, el)
}

Portal.displayName = 'ELPortal'
